export const resolverCustomer = {
  Customer: {
    async channel(obj, args, context, info) {
      return obj?.custom?.fields?.customerDistributionChannel
    },
  },
}
